import { hexToRgba, mq } from '@phishtool/ui';
import styled from 'styled-components';
import { Paragraph } from '~components/paragraph';
export const StyledFooterWrapper = styled.footer.withConfig({ displayName: "StyledFooterWrapper", componentId: "sc-1alc3eq" }) `
  background: ${(props) => hexToRgba(props.theme.colors.cultured, 0.6)};

  ${(props) => mq({
    padding: [`${props.theme.spacers.x6} 0`, null, `${props.theme.spacers.x12} 0`],
})}
`;
export const StyledFooterNav = styled.nav.withConfig({ displayName: "StyledFooterNav", componentId: "sc-1lxqlwd" }) ``;
export const StyledFooterNavList = styled.ul.withConfig({ displayName: "StyledFooterNavList", componentId: "sc-a6cab" }) `
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  row-gap: ${(props) => props.theme.spacers.x1};

  ${(props) => mq({
    columnGap: [props.theme.spacers.x2, props.theme.spacers.x3],
    justifyContent: ['center', null, 'flex-start'],
})}
`;
export const StyledFooterNavListItem = styled.li.withConfig({ displayName: "StyledFooterNavListItem", componentId: "sc-ggkf17" }) `
  a {
    ${(props) => props.theme.responsiveFontsize.body.medium}
    text-decoration: none;
    color: ${(props) => props.theme.colors.oxfordBlue};

    &:hover {
      color: ${(props) => props.theme.colors.celticBlue};
    }
  }
`;
export const StyledFooterSocialLink = styled.a.withConfig({ displayName: "StyledFooterSocialLink", componentId: "sc-1jxw3cx" }) `
  display: flex;
  text-decoration: none;
  color: ${(props) => props.theme.colors.oxfordBlue};

  &:hover {
    color: ${(props) => props.theme.colors.celticBlue};
  }
`;
export const StyledCopyrightContent = styled(Paragraph).withConfig({ displayName: "StyledCopyrightContent", componentId: "sc-1yui5es" }) `
  ${(props) => mq({
    paddingTop: [props.theme.spacers.x3, null, props.theme.spacers.x4],
    paddingLeft: [0],
    textAlign: ['center', null, 'left'],
    maxWidth: ['none', null, '765px'],
    margin: ['0px', null, '0px auto'],
})}
`;
